import { BACKEND_URL } from '../config/backendUrl';
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = BACKEND_URL || '';

const DEFAULT_LABELS = {
  credentials: 'Credentials',
  documents: 'Documents',
  forms: 'Forms',
  templates: 'Templates',
  send: 'Send',
  portal_title: 'Complete your onboarding documents below.',
};

const UILabelsContext = createContext(DEFAULT_LABELS);

export function UILabelsProvider({ children, tenantId, isPublic }) {
  const [labels, setLabels] = useState(DEFAULT_LABELS);

  const loadLabels = useCallback(async () => {
    try {
      let url;
      if (isPublic && tenantId) {
        url = `${API_URL}/api/settings/ui-labels?tenant_id=${encodeURIComponent(tenantId)}`;
      } else if (!isPublic) {
        url = `${API_URL}/api/settings/ui-labels/me`;
      } else {
        return;
      }
      const { data } = await axios.get(url);
      if (data) setLabels(prev => ({ ...prev, ...data }));
    } catch {
      // silent — use defaults
    }
  }, [tenantId, isPublic]);

  useEffect(() => { loadLabels(); }, [loadLabels]);

  return (
    <UILabelsContext.Provider value={labels}>
      {children}
    </UILabelsContext.Provider>
  );
}

export function useUILabels() {
  return useContext(UILabelsContext);
}

export { DEFAULT_LABELS };
